import { render, staticRenderFns } from "./XvostovBase.vue?vue&type=template&id=17678c9b&"
import script from "./XvostovBase.vue?vue&type=script&lang=ts&"
export * from "./XvostovBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports